import { supabase } from '@/integrations/supabase/client';

// Matches the published Terms of Service page. Change this identifier when
// that policy changes, alongside the accepted version in the migration.
export const TERMS_VERSION = 'terms-2024-01';

export async function recordTermsAcceptance(): Promise<void> {
  const { data, error } = await supabase.rpc('record_policy_acceptance', {
    p_policy_version: TERMS_VERSION,
  });
  if (error) throw new Error('Could not save your terms acceptance. Please try again.');
  if (!data) throw new Error('Terms acceptance was not recorded. Please try again.');
}
